import { useRef } from "react"
import styled from "@emotion/styled"

import { useConsole } from "contexts/Console"
import useParallax from "hooks/useParallax"

import Image from "components/media/ImageCLD"
import Video, { cssContainer } from "components/media/VideoCLD"
import BlockText from "components/push/BlockText"
import { Container, Frame, RootBase, RootFixed, getCTA } from "components/push/commons"

const Root = styled.aside`
  ${RootBase}
  ${RootFixed}

  & > div:nth-child(1) {
    overflow: hidden;
    position: sticky;
    height: var(--hh);
    top: calc(100vh - var(--hh));
  }

  /* fixed marie-louise */
  & > div + div {
    top: 100vh;
    height: 100vh;
  }

  & figure {
    height: var(--hh);
  }

  & .${cssContainer} {
    width: 100%;
    height: 100%;
  }

  img,
  & video {
    pointer-events: all;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export default function PushExtdFixed({
  image_cld: image,
  video_cld: video,
  poster,
  heading,
  chapo,
  paragraph,
  link,
  cta,
  text_width,
  parallax,
  marie_louise,
  meta,
  className,
}) {
  const console = useConsole()

  const videoProps = video?.sources?.length ? video : poster?.[0]?.video_cld
  const imageProps = image?.sources?.length ? image : poster?.[0]?.image_cld

  const ref = useRef()

  const y = useParallax(ref)

  function onClick(e) {
    if (e.target.tagName === "A") return
    const linkEl = e.currentTarget.getElementsByTagName("a")
    linkEl[0].click()
  }

  return (
    <Root className={className} style={{ zIndex: -1 - (meta ? meta.index : 0) }}>
      <Container style={{ "--ypos": parallax ? y : null, "--scale": parallax ? "1.2" : "1" }} onClick={onClick}>
        <BlockText isPush heading={heading} chapo={chapo} paragraph={paragraph} link={link} text_width={text_width}>
          {cta.length ? getCTA(Object.entries(cta[0])[0]) : null}
        </BlockText>
        <figure>
          {videoProps ? <Video autoPlay noButton {...videoProps} sizes='100vw' /> : null}
          {imageProps ? <Image {...imageProps} sizes='100vw' /> : null}
        </figure>
      </Container>
      {marie_louise ? <Frame /> : null}
    </Root>
  )
}
